import "../../../resources/less/Family/ThemePages/TimeTravelers.less";
import BaseThematique from "./BaseThematique";

class TimeTravelers extends BaseThematique {
  constructor() {
    super();
  }
}

$(window).on("load", () => {
  new TimeTravelers();
});
